// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"eee5843d","206":"97d48d14","236":"41162a71","488":"a8ef883c","529":"e287ca8c","634":"33491688","680":"4534d52d","844":"5cf2aff8","860":"00c7dbab","903":"7ed1fa83"}[chunkId] + ".chunk.js";
};